module.exports = __webpack_public_path__ + "static/media/img9.574ffca8.jpg";